
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/browse",
      function () {
        return require("private-next-pages/jobs/browse/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/browse"])
      });
    }
  